<div class="container-fluid" style="margin-top: 60px;">
  <div class="row">
    <div class="col-sm">
      <sales-period [period]="period"></sales-period>
    </div>
  </div>
</div>